/* eslint-disable global-require */
export default {
    framerate: 1,
    images: [require('./selwebee_spt_bookbirthday-TEST-ENGLISH.png')],
    frames: [
        [0, 0, 512, 512, 0, 0, 0],
        [512, 0, 512, 512, 0, 0, 0],
        [1024, 0, 512, 512, 0, 0, 0],
    ],
    animations: {
        startAnimation: {
            frames: [0, 0, 0, 0, 0, 0, 1, 1, 1, 2, 2, 2],
            next: 'idleAnimation',
            speed: 1,
        },
        idleAnimation: { frames: [2], speed: 1 },
    },
};
